<template>
  <div class="modal fade" id="infoTeamModal" role="dialog">
    <div class="modal-dialog modal-team-infos">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button v-if="!loadingModal" type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 v-if="typeModal === 1 && !loadingModal" class="certa first-title"><span>Colaboradores trabalhando</span></h5>
          <h5 v-if="typeModal === 2 && !loadingModal" class="certa first-title"><span>Colaboradores em pausa</span></h5>
          <h5 v-if="typeModal === 3 && !loadingModal" class="certa first-title"><span>Colaboradores atrasados</span></h5>
          <h5 v-if="typeModal === 4 && !loadingModal" class="certa first-title"><span>Colaboradores em intervalo/saída</span></h5>
          <h5 v-if="typeModal === 5 && !loadingModal" class="certa first-title"><span>Colaboradores sem presença</span></h5>
          <h5 v-if="typeModal === 6 && !loadingModal" class="certa first-title"><span>Colaboradores em folga/D.S.R</span></h5>
          <h5 v-if="typeModal === 7 && !loadingModal" class="certa first-title"><span>Colaboradores em afastamento</span></h5>
        </div>

        <div class="modal-body">
          <div class="modal-custom">
            <!-- Loading -->
            <div v-if="loadingModal" class="loading center_vertical">
              <div class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </div>

            <!-- Trabalhando -->
            <div v-if="typeModal === 1 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">{{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                    <table class="table">
                      <thead>
                      <tr>
                        <th class="certa"> Código </th>
                        <th class="certa"> Nome </th>
                        <th class="certa"> Email </th>
                        <th class="certa"> Equipe </th>
                        <th class="certa"> Cargo </th>
                        <th class="certa"> Hrs. trabalhadas </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="e in dataListUsers">
                        <td>#{{e.code}}</td>
                        <td>
                          <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                        </td>
                        <td>{{e.email}}</td>
                        <td>{{e.teamName}}</td>
                        <td>{{e.officeName}}</td>
                        <td>{{e.hours}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p class="nunito">Sem colaboradores trabalhando no momento.</p>
              </div>
            </div>

            <!-- Pausa -->
            <div v-if="typeModal === 2 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">Total de: {{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                    <table class="table">
                      <thead>
                      <tr>
                        <th class="certa"> Código </th>
                        <th class="certa"> Nome </th>
                        <th class="certa"> Email </th>
                        <th class="certa"> Equipe </th>
                        <th class="certa"> Cargo </th>
                        <th class="certa"> Total em pausa </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="e in dataListUsers">
                        <td>#{{e.code}}</td>
                        <td>
                          <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                        </td>
                        <td>{{e.email}}</td>
                        <td>{{e.teamName}}</td>
                        <td>{{e.officeName}}</td>
                        <td>{{e.hours}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p class="nunito">Sem colaboradores em pausa no momento.</p>
              </div>
            </div>

            <!-- Informações dos usuários trabalhando -->
            <div v-if="typeModal === 3 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">{{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                    <table class="table">
                      <thead>
                      <tr>
                        <th class="certa"> Código </th>
                        <th class="certa"> Nome </th>
                        <th class="certa"> Email </th>
                        <th class="certa"> Equipe </th>
                        <th class="certa"> Cargo </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="e in dataListUsers">
                        <td>#{{e.code}}</td>
                        <td>
                          <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                        </td>
                        <td>{{e.email}}</td>
                        <td>{{e.teamName}}</td>
                        <td>{{e.officeName}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p class="nunito">Sem colaboradores atrasados até o momento.</p>
              </div>
            </div>

            <!-- Informações dos usuários trabalhando -->
            <div v-if="typeModal === 4 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">{{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                    <table class="table">
                      <thead>
                      <tr>
                        <th class="certa"> Código </th>
                        <th class="certa"> Nome </th>
                        <th class="certa"> Email </th>
                        <th class="certa"> Equipe </th>
                        <th class="certa"> Cargo </th>
                        <th class="certa"> Total em pausa </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="e in dataListUsers">
                        <td>#{{e.code}}</td>
                        <td>
                          <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                        </td>
                        <td>{{e.email}}</td>
                        <td>{{e.teamName}}</td>
                        <td>{{e.officeName}}</td>
                        <td>{{e.hours}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p v-if="dataTeamInfo.text"class="nunito">{{dataTeamInfo.text}}</p>
                <p v-else class="nunito">Sem colaboradores em intervalo/saída no momento.</p>
              </div>
            </div>

            <!-- Informações dos usuários trabalhando -->
            <div v-if="typeModal === 5 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">{{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                    <table class="table">
                      <thead>
                      <tr>
                        <th class="certa"> Código </th>
                        <th class="certa"> Nome </th>
                        <th class="certa"> Email </th>
                        <th class="certa"> Equipe </th>
                        <th class="certa"> Cargo </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="e in dataListUsers">
                        <td>#{{e.code}}</td>
                        <td>
                          <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                        </td>
                        <td>{{e.email}}</td>
                        <td>{{e.teamName}}</td>
                        <td>{{e.officeName}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p v-if="dataTeamInfo.totalFaults" class="nunito">{{dataTeamInfo.totalFaults}}</p>
                <p v-else class="nunito">Nenhum colaborador sem presença.</p>
              </div>
            </div>

            <!-- Informações dos folga/dsr -->
            <div v-if="typeModal === 6 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">{{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="certa"> Código </th>
                          <th class="certa"> Nome </th>
                          <th class="certa"> Email </th>
                          <th class="certa"> Equipe </th>
                          <th class="certa"> Cargo </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="e in dataListUsers">
                          <td>#{{e.code}}</td>
                          <td>
                            <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                          </td>
                          <td>{{e.email}}</td>
                          <td>{{e.teamName}}</td>
                          <td>{{e.officeName}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p v-if="dataTeamInfo.totalFaults" class="nunito">{{dataTeamInfo.totalFaults}}</p>
                <p v-else class="nunito">Nenhum colaborador em folga ou D.S.R</p>
              </div>
            </div>

            <!-- Informações dos afastados -->
            <div v-if="typeModal === 7 && !loadingModal && !failRequest">
              <div class="modal-table">

                <p class="nunito txt-help" v-if="dataListUsers.length">{{dataTeamInfo.total}}</p>

                <div v-if="dataListUsers.length" class="mr-table">
                  <div class="table-responsive table-clean">
                    <div class="table-scrollable table-scrollable-borderless">
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="certa"> Código </th>
                          <th class="certa"> Nome </th>
                          <th class="certa"> Email </th>
                          <th class="certa"> Equipe </th>
                          <th class="certa"> Cargo </th>
                          <th class="certa"> Tipo </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="e in dataListUsers">
                          <td>#{{e.code}}</td>
                          <td>
                            <a v-bind:href="'/perfil/10/' + e.userId" target="_blank" class="link" v-bind:title="'Visualizar Perfil:' + e.name">{{e.name}}</a>
                          </td>
                          <td>{{e.email}}</td>
                          <td>{{e.teamName}}</td>
                          <td>{{e.officeName}}</td>
                          <td>{{e.text}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="!dataListUsers.length && !loadingModal && !failRequest" class="empty-modal">
                <p v-if="dataTeamInfo.total" class="nunito">{{dataTeamInfo.total}}</p>
                <p v-else class="nunito">Nenhum colaborador afastado.</p>
              </div>
            </div>

            <div v-if="!loadingModal && failRequest" class="empty-modal">
              <p class="nunito">Tivemos um problema com a conexão. Tente novamente atualizando a página.</p>
            </div>
          </div>
        </div>

        <div class="modal-footer offset-top-20">
          <button v-if="!failRequest && !loadingModal && dataListUsers.length >= 30 && showBtnLoadMore" v-on:click="loadMoreUserModal()" v-bind:class="{'disable': loadingMoreModal}" type="button" class="btn-yellow-save">
            <div v-if="loadingMoreModal" class="loading-btn">
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
            <span v-else>Carregar mais</span>
          </button>
          <button v-if="!loadingModal" v-on:click="closeModal()" class="close-btn" type="button">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { WHO_WORKING, WHO_IN_FAULT, WHO_ABSENCE, WHO_IN_LATE, WHO_IN_INTERVAL, WHO_IN_PAUSE, WHO_IN_DAY_OFF } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";

  export default {
    props: ['showType'],
    name: "modalInfoTeam",
    data(){
      return {
        loadingMoreModal: false,
        loadingModal: false,
        failRequest: false,
        showBtnLoadMore: true,
        typeModal: 0,
        dataTeamInfo: [],
        dataListUsers: [],
        pageNumberModal: 1,
        pageQtdModal: 30
      }
    },
    watch: {
      showType: function(val){
        this.dataTeamInfo = [];
        this.dataListUsers = [];
        this.loadingModal = true;
        this.pageNumberModal = 1;

        if (val) {
          this.typeModal = val;

          switch (val) {
            case 1:
              this.getResultFrom(WHO_WORKING, "WHO_WORKING");
              break;
            case 2:
              this.getResultFrom(WHO_IN_PAUSE, "WHO_IN_PAUSE");
              break;
            case 3:
              this.getResultFrom(WHO_IN_LATE, "WHO_IN_LATE");
              break;
            case 4:
              this.getResultFrom(WHO_IN_INTERVAL, "WHO_IN_INTERVAL");
              break;
            case 5:
              this.getResultFrom(WHO_IN_FAULT, "WHO_IN_FAULT");
              break;
            case 6:
              this.getResultFrom(WHO_IN_DAY_OFF, "WHO_IN_DAY_OFF");
              break;
            case 7:
              this.getResultFrom(WHO_ABSENCE, "WHO_ABSENCE");
              break;
          }
        }
      }
    },
    methods: {
      getResultFrom(url, constantName) {
        if (!this.loadingMoreModal) {
          this.failRequest = false;
          this.loadingMoreModal = true;

          url += "?p=" + this.pageNumberModal;
          url += "&r=" + this.pageQtdModal;
          url += "&i=" + JSON.parse(window.localStorage.getItem('userInfo')).id;
          UTIL_SERVICE.console("url:", url);

          REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console("RESULT " + constantName + ":", response.data);

            this.dataTeamInfo = response.data;

            if (typeof response.data.items !== "undefined") {
              if (response.data.items.length) {
                response.data.items.map((value, index) => {
                  this.dataListUsers.push(value);
                });
              } else {
                this.showBtnLoadMore = false;
              }
            }

            if (typeof response.data.users !== "undefined") {
              if (response.data.users.length) {
                response.data.users.map((value, index) => {
                  this.dataListUsers.push(value);
                });
              } else {
                this.showBtnLoadMore = false;
              }
            }

            this.loadingMoreModal = false;
            this.loadingModal = false;
          }).catch(reason => {
            this.loadingMoreModal = false;
            this.loadingModal = false;
            this.failRequest = true;
          });
        }
      },
      loadMoreUserModal() {
        this.pageNumberModal++;

        switch (this.typeModal) {
          case 1:
            this.getResultFrom(WHO_WORKING, "WHO_WORKING");
            break;
          case 2:
            this.getResultFrom(WHO_IN_PAUSE, "WHO_IN_PAUSE");
            break;
          case 3:
            this.getResultFrom(WHO_IN_LATE, "WHO_IN_LATE");
            break;
          case 4:
            this.getResultFrom(WHO_IN_INTERVAL, "WHO_IN_INTERVAL");
            break;
          case 5:
            this.getResultFrom(WHO_IN_FAULT, "WHO_IN_FAULT");
            break;
          case 6:
            this.getResultFrom(WHO_IN_DAY_OFF, "WHO_IN_DAY_OFF");
            break;
        }
      },
      closeModal(){
        $('#infoTeamModal').modal('toggle');
      }
    }
  }
</script>

<style lang="scss">
  .modal-dialog {
    width: 850px;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  @media (min-width: 768px) {
    .modal-dialog {
      width: 800px;
      margin: 30px auto;
    }
  }

  .disable {
    -webkit-filter: grayscale(100%);
    opacity: 0.6;
    cursor: no-drop !important;
  }

  .load-more-modal {
    border: 0;
    text-align: center;
    margin: 0 auto;
    display: block;
    left: 20px;
    color: #ffffff;
    padding: 7px 35px 7px 35px;
    background: #3598dc !important;
    font-weight: 600;
    border-radius: 4px !important;

    &:hover {
      color: #ffffff;
      background-color: #0F77AE !important;
      text-decoration: none;
    }

    .table-scrollable {
      border-bottom: 2px solid #dddddd;
    }
  }

  .default-btn-back {
    border-radius: 4px !important;
    background-color: #AAB5BC;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFFFFF;
    border: none;
    display: block;
    margin: 0 0 0 auto;

    &:hover, &:active, &:focus {
      background-color: #7b7878;
      color: #FFFFFF;
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalnfoTeam.vue